import { type IntlShape } from 'react-intl-next';
import type { Section } from '../../product-router/product/result-types';
import { messages } from './messages';
import { CrossProductScope } from './types';

export const getSections = (intl: IntlShape): Section[] => {
	const sections: Section[] = [
		{
			id: CrossProductScope.RECENTS,
			title: intl.formatMessage(messages.cross_product_recents_section_heading),
		},
		{
			id: CrossProductScope.RESULTS,
			title: intl.formatMessage(messages.cross_product_results_section_heading),
		},
	];

	return sections;
};
